// extracted by mini-css-extract-plugin
export default {"bg":"Wrapper_bg__lcZFD","outer":"Wrapper_outer__rg+lu","inner":"Wrapper_inner__fHGAL","pages":"Wrapper_pages__biOZv"};